import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M5.333 1.333H2A.667.667 0 0 0 1.333 2v3.333a.667.667 0 0 0 1.334 0V2.667h2.666a.667.667 0 0 0 0-1.334m0 12H2.667v-2.666a.667.667 0 1 0-1.334 0V14a.667.667 0 0 0 .667.667h3.333a.667.667 0 0 0 0-1.334m8.667-12h-3.333a.667.667 0 1 0 0 1.334h2.666v2.666a.667.667 0 1 0 1.334 0V2A.667.667 0 0 0 14 1.333M14 10a.667.667 0 0 0-.667.667v2.666h-2.666a.667.667 0 1 0 0 1.334H14a.667.667 0 0 0 .667-.667v-3.333A.667.667 0 0 0 14 10"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })